import { render, staticRenderFns } from "./receive-dialog.vue?vue&type=template&id=1b4095fe&scoped=true&"
import script from "./receive-dialog.vue?vue&type=script&lang=js&"
export * from "./receive-dialog.vue?vue&type=script&lang=js&"
import style0 from "./receive-dialog.vue?vue&type=style&index=0&id=1b4095fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4095fe",
  null
  
)

export default component.exports